/**
 * Rotas antigas do Financeiro (Cobrança bancária / Borderôs / Pagamentos) → tela + aba novas, preservando o resto da query.
 * Devolve o destino (`caminho?query`) ou `null` se `pathname` não é uma rota legada.
 *
 *   /financeiro/lotes-cobranca | /financeiro/borderos            → /financeiro/cobranca?aba=lotes
 *   /financeiro/cobranca-bancaria[?tab=borderos|retornos|boletos] → /financeiro/cobranca[?aba=lotes|retornos]
 *   /financeiro/pagar/agenda | /financeiro/pagamentos/agenda     → /financeiro/pagamentos
 *   /financeiro/pagar/lotes | /financeiro/pagar/remessas | /financeiro/pagamentos/remessas
 *                                                                → /financeiro/pagamentos?aba=lotes   (remessa=<id> vira lote=<id>)
 */
const ABA_DA_TAB: Record<string, string | null> = { borderos: 'lotes', retornos: 'retornos', boletos: null };

export function destinoLegado(pathname: string, search: string): string | null {
  const q = new URLSearchParams(search);
  let base: string;
  switch (pathname) {
    case '/financeiro/lotes-cobranca':
    case '/financeiro/borderos':
      base = '/financeiro/cobranca';
      q.set('aba', 'lotes');
      break;
    case '/financeiro/cobranca-bancaria': {
      base = '/financeiro/cobranca';
      const tab = q.get('tab');
      q.delete('tab');
      const aba = tab && tab in ABA_DA_TAB ? ABA_DA_TAB[tab] : null;
      if (aba) q.set('aba', aba);
      break;
    }
    case '/financeiro/pagar/agenda':
    case '/financeiro/pagamentos/agenda':
      base = '/financeiro/pagamentos';
      break;
    case '/financeiro/pagar/lotes':
    case '/financeiro/pagar/remessas':
    case '/financeiro/pagamentos/remessas':
      base = '/financeiro/pagamentos';
      q.set('aba', 'lotes');
      if (q.has('remessa') && !q.has('lote')) q.set('lote', q.get('remessa')!);
      q.delete('remessa');
      break;
    default:
      return null;
  }
  const qs = q.toString();
  return `${base}${qs ? `?${qs}` : ''}`;
}

export const ROTAS_LEGADAS_FINANCEIRO = [
  '/financeiro/lotes-cobranca',
  '/financeiro/borderos',
  '/financeiro/pagar/agenda',
  '/financeiro/pagamentos/agenda',
  '/financeiro/pagar/lotes',
  '/financeiro/pagar/remessas',
  '/financeiro/pagamentos/remessas',
] as const;
